import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { CustomButtonComponent } from "../../../../shared/components/custom-button/custom-button.component";
import { CommonModule } from '@angular/common';
import { ToastComponent } from "../../../../shared/components/toast/toast.component";
import { DeleteConfirmationDialogComponent } from "../../../../shared/dialogs/delete-confirmation-dialog/delete-confirmation-dialog.component";
import { CreateSalesAgentDialogComponent } from "../../dialogs/create-sales-agent-dialog/create-sales-agent-dialog.component";
import { ApiErrorService } from '../../../../core/api/api-error.service';
import { SalesAgentsService } from '../../../../core/api/sales-agents.service';
import { SalesAgentUsersGet } from '../../../../core/interfaces/sales-agents-interfaces';
import { HttpErrorResponse } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
import { AdminNavigationComponent } from "../../components/admin-navigation/admin-navigation.component";
import { AdminTopbarComponent } from "../../components/admin-topbar/admin-topbar.component";
import { LabeledInputComponent } from "../../../../shared/components/labeled-input/labeled-input.component";

@Component({
  selector: 'app-admin-sales-agents-page',
  standalone: true,
  imports: [TranslocoPipe, CustomButtonComponent, CommonModule, ToastComponent, DeleteConfirmationDialogComponent, CreateSalesAgentDialogComponent, AdminNavigationComponent, AdminTopbarComponent, LabeledInputComponent],
  templateUrl: './admin-sales-agents-page.component.html',
  styleUrl: './admin-sales-agents-page.component.css'
})
export class AdminSalesAgentsPageComponent implements OnInit {
  constructor(private router: Router, private apiError: ApiErrorService, private salesAgentsService: SalesAgentsService) { }

  // Toast
  @ViewChild(ToastComponent) toast!: ToastComponent;

  // Sales Agents
  salesAgents: SalesAgentUsersGet[] = [];
  loadedSalesAgents: SalesAgentUsersGet[] = [];

  lastSalesAgentsLoadedPageNumber: number = 0;
  loadMoreHiddenSalesAgents = false;

  // Crete agent dialog
  @ViewChild(CreateSalesAgentDialogComponent) createSalesAgentDialog!: CreateSalesAgentDialogComponent;

  // Agent Delete Dialog
  @ViewChild(DeleteConfirmationDialogComponent) agentDeleteDialog!: DeleteConfirmationDialogComponent;

  // Promotion Code
  promotionCodeInput: string = '';
  promotionCodeInputError: string | null = null;

  ngOnInit(): void {
    this.loadSalesAgentsNewPage();
  }

  goToDashboard() {
    this.router.navigate(["/dashboard"]);
  }

  loadSalesAgentsNewPage() {
    this.salesAgentsService.getSalesAgents((this.lastSalesAgentsLoadedPageNumber + 1)).subscribe({
      next: (response) => {
        if (response) {
          if (response.data.length === 0 || this.loadedSalesAgents.length + response.data.length >= response.totalCount) {
            this.loadMoreHiddenSalesAgents = true;
          }

          this.loadedSalesAgents = [...this.loadedSalesAgents, ...response.data];

          this.salesAgents = [];
          this.salesAgents = this.loadedSalesAgents;
        }
      },
      error: async (error) => {
        var crid = 'UNKNOWN-CRID';

        if (error instanceof HttpErrorResponse) {
          crid = error.headers?.get('x-correlation-id') || 'UNKNOWN-CRID';
        }
        this.toast.showToast(await this.apiError.getErrorHeader(), await this.apiError.getErrorMessage(crid), 'error', 8000, false);
      },
      complete: () => {
        this.lastSalesAgentsLoadedPageNumber++;
      }
    });
  }

  generateUrl(agent: SalesAgentUsersGet) {
    const pageURL = window.location.origin;
    var baseUrl = `${pageURL}/auth/signup?agent_invite=${agent.id}`;

    if (this.promotionCodeInput.trim() != '') {
      baseUrl += `&promotion=${this.promotionCodeInput.trim()}`;
    }

    return baseUrl;
  }

  copyText(text: string) {
    navigator.clipboard.writeText(text).then(() => {
      this.toast.showToast('shared.success', 'admin.invite_copied', 'success', 2000, true);
    }).catch(err => {
    });
  }

  async deleteSalesAgent(agent_id: string) {
    if (!await this.agentDeleteDialog.openModal()) {
      return;
    }

    try {
      await lastValueFrom(this.salesAgentsService.deleteSalesAgent(agent_id));

      this.reloadAgentsCallbackFunction();
    } catch (error) {
      var crid = 'UNKNOWN-CRID';
      if (error instanceof HttpErrorResponse) {
        crid = error.headers?.get('x-correlation-id') || 'UNKNOWN-CRID';
      }
      this.toast.showToast(await this.apiError.getErrorHeader(), await this.apiError.getErrorMessage(crid), 'error', 8000, false);
      return;
    }
  }

  reloadAgentsCallbackFunction = () => {
    this.lastSalesAgentsLoadedPageNumber = 0;
    this.loadedSalesAgents = [];
    this.salesAgents = [];
    this.loadSalesAgentsNewPage();
  }

  createAgent() {
    this.createSalesAgentDialog.openModal();
  }
}
